/**
 * Utility functions for estimating script duration
 */

// Average speaking rate (words per minute)
const AVERAGE_SPEAKING_RATE = 150;

// Additional time factors
const PAUSE_FACTOR = 1.2; // Account for natural pauses
const SCENE_TRANSITION_TIME = 2; // Seconds per scene transition

/**
 * Calculate estimated duration in minutes based on word count and scene count
 */
export function estimateScriptDuration(wordCount: number, sceneCount: number = 5): number {
  // Base speaking time in minutes
  const baseTime = wordCount / AVERAGE_SPEAKING_RATE;
  
  // Add time for pauses and dramatic moments
  const timeWithPauses = baseTime * PAUSE_FACTOR;
  
  // Add scene transition time
  const totalTransitionTime = (sceneCount * SCENE_TRANSITION_TIME) / 60;
  
  // Total estimated duration
  const totalDuration = timeWithPauses + totalTransitionTime;
  
  // Round to nearest minute
  return Math.round(totalDuration);
}

/**
 * Format duration for display
 */
export function formatDuration(minutes: number): string {
  if (minutes < 1) {
    return 'Less than 1 minute';
  }
  return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
}
